import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import { Button } from '../../../components';
import { short } from '../common/formatting/date';
import { differenceInYears } from 'date-fns';

const CareTeamModal = ({
	isOpen,
	onClose,
	isLoading,
	careTeam = [],
	adt = {},
}) => {
	return (
		<Modal
			isOpen={isOpen}
			contentLabel="Care Team"
			className="modal-dialog care-team-modal"
		>
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">Care Team</h3>
					</div>
				</div>
				<div className="modal-body">
					<fieldset>
						<legend>Patient</legend>
						{isLoading ? (
							<em className="fa fa-spin fa-circle-o-notch" />
						) : (
							<React.Fragment>
								<strong>
									{adt.patient_first_name} {adt.patient_last_name}
								</strong>
								<br />
								<strong>
									{adt.patient_gender === 'M' ? 'Male' : 'Female'},{' '}
									{differenceInYears(new Date(), new Date(adt.patient_dob))}
								</strong>
								<br />
								{adt.patient_address}
								<br />
								{adt.patient_city}, {adt.patient_state} {adt.patient_zip}
								<br />
								Birthdate: {short(adt.patient_dob)}
							</React.Fragment>
						)}
					</fieldset>
					<fieldset>
						<legend>Care Team</legend>
						{isLoading && <em className="fa fa-spin fa-circle-o-notch" />}
						{!isLoading && careTeam.length === 0 && (
							<p>No Care Team members found</p>
						)}
						{!isLoading && careTeam.length > 0 && (
							<React.Fragment>
								{careTeam.map(({ Id, Provider__r, Organization__r }) => (
									<div key={Id}>
										<h4>{Provider__r.Specialities__c}</h4>
										<p>
											<strong>{Provider__r.Name}</strong>
											{Provider__r.Phone && ` - ${Provider__r.Phone}`}
										</p>
										<p>
											<strong>{Organization__r.Name}</strong>
											<br />
											{Organization__r.ShippingAddress && (
												<React.Fragment>
													{Organization__r.ShippingAddress.street}
													<br />
													{Organization__r.ShippingAddress.city},{' '}
													{Organization__r.ShippingAddress.state}{' '}
													{Organization__r.ShippingAddress.postalCode}
													<br />
													{Organization__r.Phone}
												</React.Fragment>
											)}
										</p>
									</div>
								))}
								<p>
									<small>
										Patient and provider attribution matches are based on Active
										Care Relationship Files (ACRS) that are prospectively
										submitted by participating physician organizations and
										practices. ACRS files are also the source of provider
										demographic information used in this feature. Any questions
										on data accuracy or omissions should be directed to MIHIN or
										the physician organization.
									</small>
								</p>
							</React.Fragment>
						)}
					</fieldset>
				</div>
				<div className="modal-footer">
					<div className="pull-right">
						<Button title="OK" onClick={onClose} large primary className="ml" />
					</div>
				</div>
			</div>
		</Modal>
	);
};

CareTeamModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	isLoading: PropTypes.bool,
	careTeam: PropTypes.array,
	adt: PropTypes.object,
};

export default CareTeamModal;
